// Display copy only; stored values and user content remain unchanged.
const es = {
  "Test Suites": "Suites de pruebas",
  "New": "Nueva",
  "Organize and run multiple tests in sequence": "Organiza y ejecuta varias pruebas en secuencia",
  "Loading test suites...": "Cargando suites de pruebas...",
  "No Test Suites": "No hay suites de pruebas",
  "Create your first suite to batch run tests": "Crea tu primera suite para ejecutar pruebas en conjunto",
  "Create Suite": "Crear suite",
  "Add description...": "Agrega una descripción...",
  "No description": "Sin descripción",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Run": "Ejecutar",
  "Execution Configuration": "Configuración de ejecución",
  "Stop on failure": "Detener al fallar",
  "Run all tests": "Ejecutar todas las pruebas",
  "Last:": "Última:",
  "passed": "aprobadas",
  "Tests (": "Pruebas (",
  "Add Test": "Agregar prueba",
  "No tests in this suite yet": "Esta suite aún no tiene pruebas",
  "Add Tests": "Agregar pruebas",
  "Run History": "Historial de ejecuciones",
  "Loading...": "Cargando...",
  "Load More (": "Cargar más (",
  "of": "de",
  "This is an API Testing suite - only API tests can be added": "Esta suite es de pruebas de API; solo se pueden agregar pruebas de API",
  "This is a Flow Testing suite - only Flow tests can be added": "Esta suite es de pruebas de flujo; solo se pueden agregar pruebas de flujo",
  "Search tests...": "Buscar pruebas...",
  "All": "Todas",
  "Flow": "Flujo",
  "No API tests available to add": "No hay pruebas de API disponibles para agregar",
  "No Flow tests available to add": "No hay pruebas de flujo disponibles para agregar",
  "No tests available to add": "No hay pruebas disponibles para agregar",
  "Add": "Agregar",
  "Configure how flow tests in this suite will be executed.": "Configura cómo se ejecutarán las pruebas de flujo de esta suite.",
  "Browser": "Navegador",
  "Device Type": "Tipo de dispositivo",
  "Desktop": "Escritorio",
  "Mobile": "Móvil",
  "Tablet": "Tableta",
  "Environment": "Entorno",
  "Use test's default environment": "Usar el entorno predeterminado de la prueba",
  "Headless Mode": "Modo sin interfaz gráfica",
  "Always On": "Siempre activado",
  "Current Configuration": "Configuración actual",
  "Browser:": "Navegador:",
  "• Device:": "• Dispositivo:",
  "Environment:": "Entorno:",
  "Selected": "Seleccionado",
  "Test default": "Predeterminado de la prueba",
  "Save Configuration": "Guardar configuración",
  "Create Test Suite": "Crear suite de pruebas",
  "Suite Type": "Tipo de suite",
  "Flow Testing": "Pruebas de flujo",
  "Browser automation": "Automatización del navegador",
  "API Testing": "Pruebas de API",
  "REST API tests": "Pruebas de API REST",
  "Name": "Nombre",
  "e.g., Smoke Tests, Regression Suite": "Por ejemplo: pruebas de humo, suite de regresión",
  "Description": "Descripción",
  "What does this suite test?": "¿Qué valida esta suite?",
  "When a test fails": "Cuando una prueba falla",
  "Continue running": "Continuar la ejecución",
  "Run all tests even if some fail": "Ejecutar todas las pruebas aunque alguna falle",
  "Stop immediately": "Detener inmediatamente",
  "Stop the suite on first failure": "Detener la suite al primer fallo",
  "Run Results": "Resultados de la ejecución",
  "Total": "Total",
  "Passed": "Aprobadas",
  "Failed": "Fallidas",
  "Skipped": "Omitidas",
  "Project Management": "Gestión de proyectos",
  "Organize tests into projects and control team access": "Organiza las pruebas en proyectos y controla el acceso del equipo",
  "New Project": "Nuevo proyecto",
  "No projects yet. Create your first project to organize tests.": "Aún no hay proyectos. Crea tu primer proyecto para organizar las pruebas.",
  "team members with access": "miembros del equipo con acceso",
  "Edit": "Editar",
  "Edit Project": "Editar proyecto",
  "Create New Project": "Crear nuevo proyecto",
  "Project Name *": "Nombre del proyecto *",
  "My Project": "Mi proyecto",
  "Describe this project...": "Describe este proyecto...",
  "Icon": "Icono",
  "Color": "Color",
  "Team Access": "Acceso del equipo",
  "members": "miembros",
  "Admins can always access all projects": "Los administradores siempre pueden acceder a todos los proyectos",
  "Search members...": "Buscar miembros...",
  "Failed to update permissions": "No se pudieron actualizar los permisos",
  "Access granted": "Acceso concedido",
  "No members found": "No se encontraron miembros",
  "Updating...": "Actualizando...",
  "Creating...": "Creando...",
  "Update Project": "Actualizar proyecto",
  "Create Project": "Crear proyecto",
  "Project name is required": "El nombre del proyecto es obligatorio",
  "Project created successfully!": "¡Proyecto creado correctamente!",
  "Project updated successfully!": "¡Proyecto actualizado correctamente!",
  "Project deleted successfully!": "¡Proyecto eliminado correctamente!",
  "Failed to create project. Please try again.": "No se pudo crear el proyecto. Inténtalo de nuevo.",
  "Failed to update project. Please try again.": "No se pudo actualizar el proyecto. Inténtalo de nuevo.",
  "Failed to delete project. Please try again.": "No se pudo eliminar el proyecto. Inténtalo de nuevo.",
  "Delete Project": "Eliminar proyecto",
  "Confirm": "Confirmar",
  "Are you sure you want to delete \"{name}\"? Tests will remain but won't be organized.": "¿Seguro que quieres eliminar \"{name}\"? Las pruebas se conservarán, pero quedarán sin proyecto.",
  "Server error. Please try again later.": "Error del servidor. Inténtalo de nuevo más tarde.",
  "Network error. Please check your connection.": "Error de red. Comprueba tu conexión.",
  "Failed to create test suite": "No se pudo crear la suite de pruebas",
  "Failed to update test suite": "No se pudo actualizar la suite de pruebas",
  "Failed to delete test suite": "No se pudo eliminar la suite de pruebas",
  "Failed to start test suite": "No se pudo iniciar la suite de pruebas",
  "Are you sure you want to delete this test suite?": "¿Seguro que quieres eliminar esta suite de pruebas?",
  "Never": "Nunca",
  "Just now": "Ahora mismo",
  "{n}m ago": "Hace {n} min",
  "{n}h ago": "Hace {n} h",
  "{h}h {m}m ago": "Hace {h} h {m} min",
  "{n}d ago": "Hace {n} d",
  "{d}d {h}h ago": "Hace {d} d {h} h",
  "{n} total run": "{n} ejecución en total",
  "{n} total runs": "{n} ejecuciones en total",
  "{n} steps": "{n} pasos",
  "api_test": "Prueba de API",
  "flow_test": "Prueba de flujo",
  "running": "En ejecución",
  "failed": "Fallida",
  "skipped": "Omitida",
  "pending": "Pendiente",
  "completed": "Completada",
  "desktop": "Escritorio",
  "mobile": "Móvil",
  "tablet": "Tableta",
  "Edit suite": "Editar suite",
  "Delete suite": "Eliminar suite",
  "Close": "Cerrar",
  "Remove test": "Quitar prueba",
  "Delete project": "Eliminar proyecto",
  "Sprint QA Projects": "Proyectos de Sprint QA",
  "{count} Projects": "{count} proyectos",
  "Loading projects...": "Cargando proyectos...",
  "Search projects...": "Buscar proyectos...",
  "Refresh projects": "Actualizar proyectos",
  "Unassigned QA Items": "Elementos de QA sin asignar",
  "You have {requirements} requirements and {sprints} sprints not assigned to any project.": "Tienes {requirements} requisitos y {sprints} sprints sin asignar a ningún proyecto.",
  "View Unassigned": "Ver elementos sin asignar",
  "Welcome to Sprint QA": "Te damos la bienvenida a Sprint QA",
  "Create your first project to start managing sprints, requirements, and test cases.": "Crea tu primer proyecto para empezar a gestionar sprints, requisitos y casos de prueba.",
  "e.g., Mobile App, Web Platform, API Services": "Por ejemplo: app móvil, plataforma web, servicios de API",
  "Description (optional)": "Descripción (opcional)",
  "Brief description of this project": "Breve descripción de este proyecto",
  "Create Your First Project": "Crear tu primer proyecto",
  "Sprints": "Sprints",
  "Requirements": "Requisitos",
  "Test Cases": "Casos de prueba",
  "Open Project": "Abrir proyecto",
  "Project with this name already exists": "Ya existe un proyecto con este nombre",
  "Project limit reached. Your organization allows {count} projects. Ask your administrator to upgrade.": "Se alcanzó el límite de proyectos. El plan de tu organización permite {count}. Pide a tu administrador que lo actualice.",
  "Failed to create project": "No se pudo crear el proyecto"
};

export const suitesProjectsTranslator = (language) => (text, values = {}) => {
  if (typeof text !== 'string') return text;
  const template = language === 'es' ? (es[text] ?? text) : text;
  return template.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
};
